import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import React from 'react';
import { getClass } from '../../../utils/component-helpers';
import Icon from '../icon';

//	Tab takes in all props that react-router's Route Component would
const Tab = props => {
  const {
    name,
    path,
    icon,
    onSetTab,
    selected,
    subLabelComponent,
    styleType,
    url,
    iconSide,
    fittedUnderline,
  } = props;

  const iconComponent = icon ? <Icon size={21} iconName={icon} /> : null;

  const getMargin = () => {
    return icon
      ? {
          marginLeft: iconSide === 'left' ? '0' : '10px',
          marginRight: iconSide === 'left' ? '10px' : '0',
        }
      : {};
  };

  return (
    <div
      onClick={() => onSetTab && onSetTab(name)}
      className={getClass('tab', styleType, {
        selected,
      })}
    >
      <Link
        className={getClass('link', {
          underline: !fittedUnderline,
        })}
        to={`${url}/${path}`}
        style={{
          flexDirection: iconSide === 'left' ? 'row' : 'row-reverse',
        }}
      >
        <span style={{ ...getMargin() }}>{iconComponent}</span>
        <span
          className={getClass('label', {
            underline: fittedUnderline,
          })}
        >
          {name}
        </span>
        {subLabelComponent && <span className="sub-label">{subLabelComponent}</span>}
      </Link>
    </div>
  );
};

Tab.propTypes = {
  name: PropTypes.string.isRequired,
  path: PropTypes.string.isRequired,
  icon: PropTypes.string,
  iconSide: PropTypes.oneOf(['left', 'right']),
  onSetTab: PropTypes.func,
  selected: PropTypes.bool,
  subLabelComponent: PropTypes.node,
};

Tab.defaultProps = {
  subLabelComponent: null,
  onSetTab: null,
  selected: false,
  icon: null,
  iconSide: 'left',
};

export default Tab;
